import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useCondominio } from '@/features/condominios/api';
import { FeatureFlagsTab } from '@/features/feature-flags/feature-flags-tab';
import { PageContainer } from '@/components/common/page-container';
import { PageHeader } from '@/components/common/page-header';
import { Skeleton } from '@/components/ui/skeleton';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '@/components/ui/tabs';

export function CondominioSettingsRoute() {
  const { condoId } = useParams();
  const { data, isLoading } = useCondominio(condoId);
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get('tab') === 'feature-flags' ? 'feature-flags' : 'general';

  const condoIdSafe = useMemo(() => condoId ?? '', [condoId]);

  if (isLoading || !data) {
    return (
      <PageContainer width="wide">
        <Skeleton className="h-48" />
      </PageContainer>
    );
  }

  return (
    <PageContainer width="wide">
      <PageHeader
        eyebrow="Configuración"
        title={data.nombre}
        subtitle="Parámetros del condominio y feature flags."
        ruleSpacing="mb-6"
      />

      <Tabs
        value={tab}
        onValueChange={(v) => {
          const next = new URLSearchParams(searchParams);
          if (v === 'feature-flags') next.set('tab', 'feature-flags');
          else next.delete('tab');
          setSearchParams(next, { replace: true });
        }}
      >
        <TabsList>
          <TabsTrigger value="general">General</TabsTrigger>
          <TabsTrigger value="feature-flags">Feature flags</TabsTrigger>
        </TabsList>

        <TabsContent value="general" className="pt-6">
          <dl className="grid grid-cols-2 gap-6 text-sm">
            <div>
              <dt className="eyebrow">RUT</dt>
              <dd className="mt-1 font-mono">{data.rut}</dd>
            </div>
            <div>
              <dt className="eyebrow">Moneda</dt>
              <dd className="mt-1">{data.moneda}</dd>
            </div>
            <div>
              <dt className="eyebrow">Tasa mora mensual</dt>
              <dd className="mt-1 tabular">{data.tasaMoraMensualPct}%</dd>
            </div>
            <div>
              <dt className="eyebrow">Día vencimiento default</dt>
              <dd className="mt-1 tabular">{data.diaVencimientoDefault}</dd>
            </div>
          </dl>
        </TabsContent>

        <TabsContent value="feature-flags" className="pt-6">
          <FeatureFlagsTab condoId={condoIdSafe} />
        </TabsContent>
      </Tabs>
    </PageContainer>
  );
}
